"use client";

import { useTranslations } from "use-intl";

import { AddIcon, HomeIcon, ShareIcon, type AppIcon } from "@/components/appIcons";
import { cn } from "@/lib/utils";

const INSTALL_STEPS: {
  Icon: AppIcon;
  key: "installStepShare" | "installStepAddToHomeScreen" | "installStepOpenFromHomeScreen";
}[] = [
  { Icon: ShareIcon, key: "installStepShare" },
  { Icon: AddIcon, key: "installStepAddToHomeScreen" },
  { Icon: HomeIcon, key: "installStepOpenFromHomeScreen" },
];

export function BrowserPushInstallSteps({ tone = "dark" }: { tone?: "dark" | "light" }) {
  const t = useTranslations("browserPush");

  return (
    <ol className="mt-4 space-y-2" aria-label={t("installTitle")}>
      {INSTALL_STEPS.map(({ Icon, key }) => (
        <li
          className={cn(
            "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold",
            tone === "dark" ? "bg-white/[0.06] text-[#e2ded5]" : "bg-muted text-foreground",
          )}
          key={key}
        >
          <span
            className={cn(
              "flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary/15",
              tone === "dark" ? "text-[#f4a17f]" : "text-primary",
            )}
          >
            <Icon decorative />
          </span>
          <span>{t(key)}</span>
        </li>
      ))}
    </ol>
  );
}
